import { styled, Table, Theme } from '@mui/material';

export const StyledTable = styled(Table)(({ theme }) => ({
  '& .MuiTableCell-root': {
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0.5, 1),
      height: theme.spacing(7),
    },
  },
  [theme.breakpoints.down('md')]: {
    borderCollapse: 'inherit',
    paddingBottom: theme.spacing(2),
  },
}));

// Figma 1695:3690 / 1655:7911: the newer designs' table. Colours from the theme; the border is
// the design's neutral-variant 90, which has no theme token.
const NAVY_TABLE_BORDER = '#E2E2E9';

export const NAVY_TABLE_SX = (theme: Theme) => ({
  border: `1px solid ${NAVY_TABLE_BORDER}`,
  borderRadius: '8px',
  '& .MuiTableHead-root .MuiTableCell-root': {
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.common.white,
    height: 44,
    paddingY: 0,
    paddingX: 3,
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '0.5px',
    borderBottom: 'none',
  },
  // Sort labels and their arrows stay white, active or not.
  '& .MuiTableHead-root .MuiTableSortLabel-root, & .MuiTableHead-root .MuiTableSortLabel-root.Mui-active, & .MuiTableHead-root .MuiTableSortLabel-icon':
    { color: `${theme.palette.common.white} !important` },
  '& .MuiTableBody-root .MuiTableCell-root': {
    height: 48,
    paddingY: 0,
    paddingX: 3,
    fontSize: 14,
    lineHeight: '20px',
    borderBottom: `1px solid ${NAVY_TABLE_BORDER}`,
  },
  '& .MuiTableBody-root .MuiTableRow-root:last-of-type .MuiTableCell-root': { borderBottom: 'none' },
});
